export default "__VITE_ASSET__a61a85d3__"